/**
 * True when redux-persist has a cached authenticated user (localStorage on web).
 * Does not prove the server session cookie is still valid — always verify via getSession.
 * Requires a real user id (INITIAL_STATE always has an empty userData shell).
 */
export function hasPersistedWebSession(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const raw = localStorage.getItem('persist:root');
    if (!raw) return false;
    const root = JSON.parse(raw) as { promiseData?: string };
    if (!root.promiseData) return false;
    const promiseData = JSON.parse(root.promiseData) as {
      isAuthenticated?: boolean;
      data?: { userData?: { id?: string } | null };
    };
    return Boolean(
      promiseData?.isAuthenticated && promiseData?.data?.userData?.id
    );
  } catch {
    return false;
  }
}

export function isDashboardPath(path: string): boolean {
  return path === '/dashboard' || path.startsWith('/dashboard/');
}
